// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import React from 'react';
import './Portal.css';

const Portal = ({ isActive }) => {
  return (
    <div className={`portal-container ${isActive ? 'active' : ''}`}>
      <div className="portal">
        <div className="portal-ring ring-1"></div>
        <div className="portal-ring ring-2"></div>
        <div className="portal-ring ring-3"></div>
        <div className="portal-core">
          <div className="energy-swirl"></div>
          <div className="energy-particles"></div>
        </div>
        <div className="warp-lines">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="warp-line" style={{
              '--delay': `${i * 0.1}s`,
              '--angle': `${i * 18}deg`
            }}></div>
          ))}
        </div>
      </div>
      {isActive && (
        <div className="portal-effects">
          <div className="energy-burst"></div>
          <div className="space-distortion"></div>
        </div>
      )}
    </div>
  );
};

export default Portal;